export default "/rsETH-WETH-BPT.3d3354b908785c417b331852bad83760.png";